import { createTheme } from '@mui/material/styles';

export const theme = createTheme({
    palette: {
        primary: {
            main: "#F8B42A",
            contrastText: "#fff"
        },
        error: {
            main: "#C1292E",
            light: "rgba(193, 41, 46, 0.20)"
        },
        success: {
            main: "#4CAF50",
            light: "rgba(76, 175, 80, 0.20)"
        }
    },
    components: {
        MuiDivider: {
            styleOverrides: {
                root: {
                    borderColor: "#C9C9C9"
                }
            }
        }
    }
});
